const CDN_MAPPING = {
  'https://storage.googleapis.com/connectedleaguedata.appspot.com':
    'https://data-20ca4.kxcdn.com',
  'https://storage.googleapis.com/connectedleague-information.appspot.com':
    'https://information-20ca4.kxcdn.com',
  'https://img.svenskelitfotboll.se/player':
    'https://information-20ca4.kxcdn.com/player',
  'https://img.svenskelitfotboll.se/staff':
    'https://information-20ca4.kxcdn.com/staff',
  'https://img.svenskelitfotboll.se':
    'https://information-20ca4.kxcdn.com/player',
  'https://cl-match-card-bgs-sthlm.s3.eu-north-1.amazonaws.com':
    'https://matchcards-20ca4.kxcdn.com',
};

const IMG_HOSTS = Object.keys(CDN_MAPPING);

function getSizeInPixel(size) {
  return (size || 500) * Math.round(window.devicePixelRatio || 1);
}

export function getProxyUrl(url, height, width) {
  const baseUrl = url && IMG_HOSTS.find((key) => url.indexOf(key) === 0);

  if (baseUrl) {
    const widthInPixel = getSizeInPixel(width);

    const newUrl = new URL(url.replace(baseUrl, CDN_MAPPING[baseUrl]));
    newUrl.searchParams.set('width', widthInPixel);
    return newUrl.toString();
  }

  return url;
}

/* eslint-disable no-param-reassign */
export function fallbackImageErrorHandler(fallbackImageUrl) {
  return ({ currentTarget }) => {
    currentTarget.onerror = null;
    currentTarget.src = fallbackImageUrl || window.fallbackImageUrl;
  };
}

export const defaultImageErrorHandler = fallbackImageErrorHandler();
